(() => {
  'use strict';

  const drawerSelector = 'header-drawer[data-pemixe-accordion]';

  function initializeDrawer(drawer) {
    if (drawer.hasAttribute('data-pemixe-accordion-ready')) return;

    const navigation = drawer.querySelector('.menu-drawer__navigation');
    if (!navigation) return;

    const submenuDetails = Array.from(
      navigation.querySelectorAll('details')
    ).filter((details) => {
      return (
        details.querySelector(':scope > summary') &&
        details.querySelector(':scope > .menu-drawer__submenu')
      );
    });

    if (!submenuDetails.length) return;

    const submenuSet = new Set(submenuDetails);

    function summaryFor(details) {
      return details.querySelector(':scope > summary');
    }

    function syncState(details) {
      const summary = summaryFor(details);
      if (!summary) return;

      summary.setAttribute('aria-expanded', String(details.open));

      summary.querySelectorAll(':scope > .svg-wrapper').forEach((icon) => {
        icon.setAttribute('aria-hidden', 'true');
      });
    }

    function collapse(details) {
      details.open = false;
      details.classList.remove('menu-opening');

      details.querySelectorAll('details').forEach((child) => {
        if (!submenuSet.has(child)) return;

        child.open = false;
        child.classList.remove('menu-opening');
        syncState(child);
      });

      syncState(details);
    }

    submenuDetails.forEach((details) => {
      const summary = summaryFor(details);
      const panel = details.querySelector(':scope > .menu-drawer__submenu');

      if (panel.id) {
        summary.setAttribute('aria-controls', panel.id);
      }

      syncState(details);

      details.addEventListener('toggle', () => {
        if (!details.open) {
          collapse(details);
        } else {
          syncState(details);
        }
      });
    });

    /*
     * Capture submenu clicks before Dawn's individual summary handlers.
     * Links and the main hamburger summary are left untouched.
     */
    drawer.addEventListener(
      'click',
      (event) => {
        if (!(event.target instanceof Element)) return;

        const summary = event.target.closest('summary');
        if (!summary || !navigation.contains(summary)) return;

        const details = summary.parentElement;
        if (!submenuSet.has(details)) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (details.open) {
          collapse(details);
        } else {
          details.open = true;
          syncState(details);
        }
      },
      true
    );

    /*
     * Escape closes the current submenu and returns focus to its parent.
     * Escape outside a submenu continues to use Dawn's drawer handler.
     */
    drawer.addEventListener(
      'keyup',
      (event) => {
        if (event.key !== 'Escape' && event.code !== 'Escape') return;
        if (!(event.target instanceof Element)) return;

        let details = event.target.closest('details');

        while (details && navigation.contains(details)) {
          if (submenuSet.has(details) && details.open) {
            event.preventDefault();
            event.stopImmediatePropagation();

            collapse(details);
            summaryFor(details).focus();
            return;
          }

          details = details.parentElement?.closest('details');
        }
      },
      true
    );

    drawer.setAttribute('data-pemixe-accordion-ready', '');
  }

  function initializeAll() {
    document.querySelectorAll(drawerSelector).forEach(initializeDrawer);
  }

  async function start() {
    await customElements.whenDefined('header-drawer');
    initializeAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
